import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import SellerReputationBanner from '../../../../components/seller-reputation-banner';
import withRow from '../../../../components/grid/row/with-row';
import jsonToProps from '../../../../components/seller-reputation-banner/jsonToProps';

const FEATURE_NAME = 'seller_reputation_banner';

const mapStateToProps = ({ components: { [FEATURE_NAME]: sellerReputationBanner } }) =>
  jsonToProps(sellerReputationBanner);

const enhance = compose(
  withFeatureFlag(FEATURE_NAME),
  withRow(FEATURE_NAME),
  connect(mapStateToProps),
);

const isSellerReputationBannerVisible = components =>
  (components[FEATURE_NAME] && components[FEATURE_NAME].state === 'VISIBLE') || false;

export default enhance(SellerReputationBanner);
export { isSellerReputationBannerVisible };
